export default [
  { value: 'Invoice Date', align: 'center' },
  { value: 'Invoice #', align: 'center' },
  { value: 'Description', align: 'left' },
  { value: 'Orig. Amt.', align: 'right' },
  { value: 'Amt. Due', align: 'right' },
  { value: 'Disc. Taken', align: 'right' },
  { value: 'Payment', align: 'right' },
].map(({ value, align }, key) => ({ value, align, key }));
